import { lazy } from 'react'

const Login = lazy(() => import('./Login'))
const SignUp = lazy(() => import('./SignUp'))
const NotFound = lazy(() => import('./NotFound'))
const compliteRegistration = lazy(() => import('./CompleteRegistration'))
const ForgotPassword = lazy(() => import('./ForgotPassword'))
const ResetPassword = lazy(() => import('./ResetPassword'))

const authRoutes = [
    {
        path: '/login',
        component: Login,
    },
    {
        path: '/signup',
        component: SignUp,
    },
    {
        path: '/forgot-password',
        component: ForgotPassword,
    },
    {
        path: '/reset-password',
        component: ResetPassword,
    },
    {
        path: '/session/404',
        component: NotFound,
    },
    {
        path: '/complete_registration',
        component: compliteRegistration,
    },
]

export default authRoutes 